export default __webpack_public_path__ + "static/center-en-414b98237a1101b74c4c5431e6302e22.webp";